import React from "react"
import "./leetcode.scss"
import LeetCode from "./LeetCode"


export default LeetCode
